import React from 'react';
import img from './nopermission.png';

export default function () {
  return (
    <div style={{ textAlign: 'center' }}>
      <img src={img} style={{ width: 133, height: 109 }} />
      <div>暂无权限，请联系管理员</div>
    </div>
  );
}
